class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    gsap.registerPlugin(ScrollTrigger);

    gsap.to(".js-bg", 
      { 
        scrollTrigger: {
          trigger: ".js-bg",
          start: "top center", 
          onEnter: () => {
            $('.js-bg').addClass('is-active');
          }
        }
      }
    );

    gsap.to(".scroll-anime", 
      { 
        scrollTrigger: {
          trigger: ".scroll-anime",
          start: "top top", 
          end: "top+=1000 top", 
          pin: true,
        }
      }
    )

    gsap.fromTo(".scroll-anime-bg-after", 
      {
        opacity: 0,
      },
      { 
        opacity: 1,
        scrollTrigger: {
          trigger: ".scroll-anime-trigger",
          start: "top-=400 top", 
          end: "top top", 
          scrub: 0.4,
        }
      }
    )

    gsap.fromTo(".scroll-anime-ttl", 
      {
        opacity: 0,
        filter: "blur(30px)",
        y: 300,
      },
      { 
        opacity: 1,
        filter: "blur(0px)",
        y: 0,
        scrollTrigger: {
          trigger: ".scroll-anime-trigger",
          start: "top+=100 top", 
          end: "top+=400 top", 
          scrub: 0.4,
        }
      }
    )

    gsap.fromTo(".scroll-anime-txt", 
      {
        opacity: 0,
        y: 300,
      },
      { 
        opacity: 1,
        y: 0,
        scrollTrigger: {
          trigger: ".scroll-anime-trigger",
          start: "top+=300 top", 
          end: "top+=600 top", 
          scrub: 0.4,
        }
      }
    )


    // Swiperのインスタンスを保持する変数
    var swiperInstance;

    // Swiperを初期化する関数
    let swiperTouchStartX;

    function initSwiper() {
      if (window.innerWidth > 768) {
        swiperInstance = new Swiper('.news-swiper', {
          slidesPerView: 3.6,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          speed: 500, // スライドの速度をミリ秒単位で指定
          on: {
            init(swiper) {
              // スライド総数
              const totalSlidesLen = swiper.slides.length;
            },
            /**
             * Swiper上でドラッグされ始めたときの処理
             */
            touchStart(swiper, e) {
              /**
               * タッチされたX座標を保存
               * タッチ時とクリック時でイベントの返り値が変わるため処理を分岐
               */
              if (e.type === 'touchstart') {
                swiperTouchStartX = e.touches[0].clientX;
              } else {
                swiperTouchStartX = e.clientX;
              }
            },
            /**
             * Swiper上でドラッグし終わったときの処理
             */
            touchEnd(swiper, e) {
              // スワイプ判定のしきい値
              const tolerance = 150;
              // スライド総数
              const totalSlidesLen = swiper.slides.length;
        
              // 左にスワイプしたか右にスワイプしたかを判定
              const diff = (() => {
                if (e.type === 'touchend') {
                  return e.changedTouches[0].clientX - swiperTouchStartX;
                } else {
                  return e.clientX - swiperTouchStartX;
                }
              })();
        
              /**
               * タッチ開始時と、タッチ終了時のカーソルの座標を比較し、下記のどちらかに分岐させる。
               */
              // 最初のスライド上で左にスワイプされたときは最後のスライドに飛ばす
              if (swiper.isBeginning && diff >= tolerance) {
                swiper.slideTo(totalSlidesLen - 1);
              // 最後のスライド上で右にスワイプさせたときは最初のスライドに飛ばす
              } else if (swiper.isEnd && diff <= -tolerance) {
                // 一瞬待ってから最初のスライドに飛ばす
                // （少し遅らせないと、最初のスライドに戻った後に右スワイプ判定が走って2番目のスライドに飛ばされてしまうため）
                setTimeout(() => {
                  swiper.slideTo(0);
                }, 1);
              }
            },
          },
        });

        swiperInstance.autoplay.stop();

        let options = {
          threshold: [0.8, 0.9 ,1]
        }
    
        const observerEnter = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const item = entry.target;
            if(entry.intersectionRatio >= 0.05){
              swiperInstance.autoplay.start();
            }
          });
        }, options);
    
        let swiperEl = document.querySelectorAll('.news-swiper');
    
        swiperEl.forEach((e)=>{
          observerEnter.observe(e);
        });

      } else if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }

    // ページの読み込み時とリサイズ時にSwiperを初期化または破棄する
    (function() {
      initSwiper();
      window.addEventListener('resize', function() {
        initSwiper();
      });
    })();
  }
}